import { parseSvgStyle } from '@/icons/utils/svg-styles'
import { ISvgProps } from '@/icons/utils/svg-types'

export const SvgFilledChevronRight = (props: ISvgProps) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={parseSvgStyle(props)}
            className={props.className}
        >
            <g id="arrow_right_24px">
                <path
                    id="icon/navigation/arrow_right_24px"
                    d="M9.5 17L14.5 12L9.5 7V17Z"
                    fill={props.color}
                />
            </g>
        </svg>
    )
}
